import { DateTime } from 'luxon';
import { config } from '../config';

export function formatDateTime(dateTimeString: string) {
  if (!dateTimeString) return 'Date not available.';

  const dateTime = DateTime.fromISO(dateTimeString, {
    zone: config.lodgingLocationTimezone,
  });
  const formattedDateTime = dateTime.toFormat('LLL dd, yyyy @ hh:mm a');

  return formattedDateTime;
}
